import { render } from "./plCookieBanner.vue?vue&type=template&id=72211bd8"
import script from "./plCookieBanner.vue?vue&type=script&lang=js"
export * from "./plCookieBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__